namespace Solovis.Reports.DataSetHelpers {

    export interface SpecificRequestedResourcePropertyValue {    
        resourceId;
        propDefId;
        dayId;        
        exactDayOnly: boolean;
    }

    export class SpecificRequestedValueSet {
        resourceIds: number[] = [];
        propDefIds: number[] = [];
        dayIds: number[] = [];
        exactDayOnly: boolean = false;

        public AddRequestedValue(resourceId, propDefId, dayId) {
            if (dayId != null && this.dayIds.indexOf(dayId) < 0)
                this.dayIds.push(dayId);
            if (resourceId != null && this.resourceIds.indexOf(resourceId) < 0)
                this.resourceIds.push(resourceId);
            if (propDefId != null && this.propDefIds.indexOf(propDefId) < 0)
                this.propDefIds.push(propDefId);
        }
    }

    export interface IndirectRequestedResourcePropertyValueStackEntry {
        propDefId;
        dayId;
        exactDayOnly: boolean;
    }

    export interface IndirectRequestedResourcePropertyValue {
        /**
         * This array must be evaluated from last entry back to first to pull subsequent property values.
         */
        indirectLoadStack: IndirectRequestedResourcePropertyValueStackEntry[];
        request: SpecificRequestedResourcePropertyValue;
    }

    /**
     * SpecificResourcePropertyValuesIndex is used by PropValuesToIncludeHelper to facilitate custom property inclusion
     * on report tables. The data set expected is the data set returned from  "/Solovis/Metadata/SpecificResourcePropertyValues"
     * data set.
     */
    export class SpecificResourcePropertyValuesIndex {

        private _portalServices: Solovis.Portal.IPortalServices;
        private _dataSet;
        private _resourceIdToPropDataMap;
        private _modelEnv: InvData.ModelEnvironment;

        private _propDefIdsSeenSet = {};

        private _entityIdToResourceIdMap = {};


        constructor(options) {
            if (options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            let dataSet = options.dataSet;
            let modelEnv = options.modelEnvironment;

            this._dataSet = dataSet;
            this._modelEnv = modelEnv;

            this._resourceIdToPropDataMap = {};

            $(dataSet.propertyValues).each((i, propValue) => {
                this._augmentResourcePropertyValue(propValue);
                this._addOrUpdateValue(propValue);
            });
        }

        public static async createAsync(options): Promise<SpecificResourcePropertyValuesIndex> {
            let portalServices: Solovis.Portal.IPortalServices;
            if (options.portalServices) {
                portalServices = options.portalServices;
            }
            else {
                portalServices = new Solovis.Portal.SitePortalServices();
            }

            let dataSet = options.dataSet;
            let modelEnv: InvData.ModelEnvironment = options.modelEnvironment;

            if (!modelEnv) {
                modelEnv = new InvData.ModelEnvironment();
            }

            let propDefs = await portalServices.modelEnvironmentCachedData().getPropertyDefinitionsAsync();
            let propDefModelEnv = new InvData.ModelEnvironment();
            propDefModelEnv.propertyDefinitions = propDefs;

            modelEnv.mergeEnvironmentData(propDefModelEnv);

            let index = new SpecificResourcePropertyValuesIndex({
                portalServices: portalServices,
                dataSet: dataSet,
                modelEnvironment: modelEnv
            });

            return index;
        }


        public _addOrUpdateValue(propValue) {
            if (!propValue) {
                return;
            }

            this._propDefIdsSeenSet[propValue.propertyDefinitionId] = true;

            let propData;
            if (this._resourceIdToPropDataMap[propValue.resourceId]) {
                propData = this._resourceIdToPropDataMap[propValue.resourceId];
            }
            else {
                propData = {
                    propIdToValueDataMap: {}
                };
                this._resourceIdToPropDataMap[propValue.resourceId] = propData;
            }

            let valueData;
            if (propData.propIdToValueDataMap[propValue.propertyDefinitionId]) {
                valueData = propData.propIdToValueDataMap[propValue.propertyDefinitionId];
            }
            else {
                valueData = {
                    values: []
                };
                propData.propIdToValueDataMap[propValue.propertyDefinitionId] = valueData;
            }

            let added = false;
            for (let valueCo = 0; valueCo < valueData.values.length; valueCo++) {
                let currentValue = valueData.values[valueCo];
                if (currentValue.value.from == propValue.value.from) {
                    // Overwrite the current value.
                    valueData.values[valueCo] = propValue;
                    added = true;
                    break;
                }
                else if (propValue.value.from < currentValue.value.from) {
                    // Insert the new value before the current one.
                    valueData.values.splice(valueCo, 0, propValue);
                    added = true;
                    break;
                }
            }
            if (!added) {
                valueData.values.push(propValue);
            }
        }

        public _augmentResourcePropertyValue(propValue) {
            var propDefId = propValue.propertyDefinitionId;
            var propDef = this._modelEnv.propertyDefinitions.tryGetById(propDefId);
            if (propDef) {
                propValue.property = propDef;

                // Set up valueStrings/HtmlList.
                if (!propValue.valueStrings) {
                  InvData.Util.TouchUpValueStringByPropertyType(propDef.propertyTypeId, propValue);
                }
            }
        }

        public getPropValue(resourceId, propDefId, dayId, exactDayOnly) {
            if (_.isArray(resourceId)) {
                // if resourceId is an array, then this should try to retrieve value for each property in order and then
                // only return value for the resource that has the property.
                for (let resourceIdEntry of resourceId) {
                    let propValue = this.getPropValue(resourceIdEntry, propDefId, dayId, exactDayOnly);
                    if (propValue) {
                        return propValue;
                    }
                }
            }
            else {
                let propData = this._resourceIdToPropDataMap[resourceId];
                if (propData) {
                    let valueData = propData.propIdToValueDataMap[propDefId];
                    if (valueData) {
                        let mostRecentValueFound = null;

                        for (let propValue of valueData.values) {
                            let value = propValue.value;
                            if (value.from === dayId) {
                                return propValue;
                            }
                            else {
                                if (!exactDayOnly) {
                                    if (value.from <= dayId) {
                                        if (!mostRecentValueFound || value.from > mostRecentValueFound.value.from) {
                                            mostRecentValueFound = propValue;
                                        }
                                    }
                                }
                            }
                        }

                        return mostRecentValueFound;
                    }
                }

                return null;
            }            
        }


        public async processIndirectLoads(indirectRequests: IndirectRequestedResourcePropertyValue[]): Promise<void> {
            let remainingIndirects: IndirectRequestedResourcePropertyValue[] = indirectRequests;

            while (remainingIndirects != null && remainingIndirects.length > 0) {
                let newRemainingIndirects: IndirectRequestedResourcePropertyValue[] = [];
                let newServerRequests: SpecificRequestedResourcePropertyValue[] = [];

                let hasEntityLookupRequest = false;
                let entityIdLookupRequests = {};

                for (let indirectRequest of remainingIndirects) {
                    let request = indirectRequest.request;
                    let propValue = this.getPropValue(request.resourceId, request.propDefId, request.dayId, request.exactDayOnly);
                    let propDef = this._modelEnv.propertyDefinitions.tryGetById(request.propDefId);

                    let newResourceId = null;                    

                    if (propValue && propDef) {
                        if (propDef.propertyTypeId === InvData.PropertyTypeIds.ContactRef
                            || propDef.propertyTypeId === InvData.PropertyTypeIds.InvestmentRef
                            || propDef.propertyTypeId === InvData.PropertyTypeIds.TransactionRef
                            || propDef.propertyTypeId === InvData.PropertyTypeIds.ManagerRef
                        ) {
                            if (propValue.value && propValue.value.r && propValue.value.r.length > 0) {
                                newResourceId = propValue.value.r[0];
                            }
                        }
                        else if (propDef.propertyTypeId === InvData.PropertyTypeIds.EntityRef) {
                            if (propValue.value && propValue.value.e && propValue.value.e.length > 0) {
                                let entityId = propValue.value.e[0];
                                if (entityId) {
                                    let entityResourceId = this._entityIdToResourceIdMap[entityId];
                                    if (typeof entityResourceId === "undefined") {
                                        // Lookup the entity's resourceId and try again.
                                        newRemainingIndirects.push(indirectRequest);
                                        entityIdLookupRequests[entityId] = true;      
                                        hasEntityLookupRequest = true;
                                    }
                                    else {
                                        if (entityResourceId !== false) {
                                            newResourceId = entityResourceId;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if (newResourceId) {
                        let nextIndirect = indirectRequest.indirectLoadStack.pop();

                        if (nextIndirect) {
                          let newRequest: SpecificRequestedResourcePropertyValue = {
                            resourceId: newResourceId,
                            dayId: nextIndirect.dayId,
                            propDefId: nextIndirect.propDefId,
                            exactDayOnly: nextIndirect.exactDayOnly
                          };

                          newServerRequests.push(newRequest);

                          if (indirectRequest.indirectLoadStack.length > 0) {
                            newRemainingIndirects.push({
                              indirectLoadStack: indirectRequest.indirectLoadStack,
                              request: newRequest
                            });
                          }
                        }          
                    }
                }

                if (newServerRequests.length > 0) {
                    let params = {
                        requestedValues: newServerRequests,
                        includeValueStrings: true,
                        includeMetadata: true
                    };

                    let propValueResponse = await this._portalServices.reportDataLoader().loadDataSetAsync(
                        "/Solovis/Metadata/SpecificResourcePropertyValues",
                        params);

                    let loadedDataSet = propValueResponse.result.dataSet;
                    if (loadedDataSet) {
                        $(loadedDataSet.propertyValues).each((i, propValue) => {
                            this._augmentResourcePropertyValue(propValue);
                            this._addOrUpdateValue(propValue);                            
                        });
                    }
                }                

                if (newServerRequests.length === 0 && !hasEntityLookupRequest) {                    
                    remainingIndirects = null;
                }
                else {
                    remainingIndirects = newRemainingIndirects;

                    if (hasEntityLookupRequest) {
                        let entityIds: number[] = [];
                        for (let entityId in entityIdLookupRequests) {
                            if (entityIdLookupRequests.hasOwnProperty(entityId)) {
                                entityIds.push(parseInt(entityId));
                            }
                        }

                        let entityResponse = await this._portalServices.reportDataLoader().loadDataSetAsync(
                            "/Solovis/Metadata/ModelEnvironment",
                            {
                                entityOptions: {
                                    entityIdsToLoad: entityIds
                                }
                            });
                        
                        let modelEnvDataSet = entityResponse.result.dataSet;
                        if (modelEnvDataSet && modelEnvDataSet.modelEnvironment) {
                            let entityModelEnv = modelEnvDataSet.modelEnvironment
                            if (entityModelEnv && entityModelEnv.entities) {
                                for (let entity of entityModelEnv.entities) {
                                    this._entityIdToResourceIdMap[entity.id] = entity.resourceId;
                                }
                            }
                        }

                        for (let entityId of entityIds) {
                            // If no resourceId was found for one of the entities, let's mark it as false.
                            let entityResourceId = this._entityIdToResourceIdMap[entityId];
                            if (typeof entityResourceId === "undefined") {
                                this._entityIdToResourceIdMap[entityId] = false;
                            }
                        }
                    }
                }
            }
        }


        public getLineItemPropValueInstanceForPropValueToInclude(
            lineItem,
            lineItemToResourceId,
            lineItemToAsOfDayId,
            propValueToInclude: Solovis.Reports.Parameters.PropValueIncludes.PropValueToInclude) {

            let valueGetter = (currentPropValueInclude: Solovis.Reports.Parameters.PropValueIncludes.PropValueToInclude) => {
                if (currentPropValueInclude.resourceRef === "indirect") {       
                    if (currentPropValueInclude.indirectRef) {
                        let indirectRef = currentPropValueInclude.indirectRef;
                        let nestedValue = valueGetter(indirectRef);
                        if (nestedValue) {
                            let nestedPropDef = this._modelEnv.propertyDefinitions.tryGetById(indirectRef.propDefId);
                            if (nestedPropDef) {
                                let newResourceId = null;

                                if (nestedPropDef.propertyTypeId === InvData.PropertyTypeIds.ContactRef
                                    || nestedPropDef.propertyTypeId === InvData.PropertyTypeIds.InvestmentRef
                                    || nestedPropDef.propertyTypeId === InvData.PropertyTypeIds.TransactionRef
                                    || nestedPropDef.propertyTypeId === InvData.PropertyTypeIds.ManagerRef
                                ) {
                                    if (nestedValue.value && nestedValue.value.r && nestedValue.value.r.length > 0) {
                                        newResourceId = nestedValue.value.r[0];
                                    }
                                }
                                else if (nestedPropDef.propertyTypeId === InvData.PropertyTypeIds.EntityRef) {
                                    if (nestedValue.value && nestedValue.value.e && nestedValue.value.e.length > 0) {
                                        let nestedEntityId = nestedValue.value.e[0];
                                        let nestedResourceId = this._entityIdToResourceIdMap[nestedEntityId];

                                        if (nestedResourceId !== false) {
                                            newResourceId = parseInt(nestedResourceId);
                                        }
                                    }
                                }

                                if (newResourceId) {
                                    let dayId = lineItemToAsOfDayId(lineItem, currentPropValueInclude.dateRef);
                                    let propValue = this.getPropValue(newResourceId, currentPropValueInclude.propDefId, dayId, currentPropValueInclude.exactDayOnly);
                                    return propValue;
                                }
                            }
                        }
                    }           
                    
                    return null;                    
                }
                else {                    
                    let resourceId = lineItemToResourceId(lineItem, currentPropValueInclude.resourceRef);
                    let dayId = lineItemToAsOfDayId(lineItem, currentPropValueInclude.dateRef);
                    let propValue = this.getPropValue(resourceId, currentPropValueInclude.propDefId, dayId, currentPropValueInclude.exactDayOnly);

                    return propValue;
                }
            }

            let valueToUse = valueGetter(propValueToInclude);

            return valueToUse;
        }


        public async ensureAllTagSetsAvailable(): Promise<void> {
            let missingTagSetIdsSeen = {};
            let missingTagSetIds = [];

            for (let propDefId in this._propDefIdsSeenSet) {
                if (this._propDefIdsSeenSet.hasOwnProperty(propDefId)) {
                    let propDef = this._modelEnv.propertyDefinitions.tryGetById(parseInt(propDefId));
                    if (propDef.propertyTypeId === InvData.PropertyTypeIds.TagRef) {
                        if (propDef.tagRefTagSetId) {
                            let existingTagSet = this._modelEnv.tagSets.tryGetById(propDef.tagRefTagSetId);
                            if (!existingTagSet) {
                                let loadedTagSet = await this._portalServices.modelEnvironmentCachedData().tryGetTagSetByIdAsync(propDef.tagRefTagSetId);
                                if (loadedTagSet) {
                                    this._modelEnv.tagSets.addOrReplace(loadedTagSet);
                                }
                            }
                        }
                    }
                }
            }
            
        }
    }
}